import { render, staticRenderFns } from "./createTransfer.vue?vue&type=template&id=2fe3b795&scoped=true&"
import script from "./createTransfer.vue?vue&type=script&lang=js&"
export * from "./createTransfer.vue?vue&type=script&lang=js&"
import style0 from "./createTransfer.vue?vue&type=style&index=0&id=2fe3b795&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe3b795",
  null
  
)

export default component.exports